function processSorting(criterion, data, descendant) {
    switch (true) {
        case data.every(item => typeof item[criterion] === 'number'):
            return data.sort((a, b) => {
                if (descendant) {
                    return b[criterion] - a[criterion]
                } else {
                    return a[criterion] - b[criterion]
                }
            });
        case data.every(item => typeof item[criterion] === 'string'):
            return data.sort((a, b) => {
                if (descendant) {
                    return ('' + b[criterion]).localeCompare(a[criterion])
                } else {
                    return ('' + a[criterion]).localeCompare(b[criterion])
                }
            });
        default:
            return data.sort((a, b) => {
                if (descendant) {
                    return ('' + b[criterion]).localeCompare(a[criterion])
                } else {
                    return ('' + a[criterion]).localeCompare(b[criterion])
                }
            });
    }
}

function processGrouping(criterion, data, descendant) {

    let newData = [];
    let groupNames = [];

    data.map(app => {

        let appCriterion = app[criterion] || `No ${criterion}`;

        if (Array.isArray(appCriterion)) {
            appCriterion = appCriterion.sort((a, b) => ('' + a[criterion]).localeCompare(b[criterion]))
            appCriterion = appCriterion.join(', ');
        }

        if (!groupNames?.some(name => name.toLowerCase() === appCriterion.toLowerCase())) {
            groupNames.push(appCriterion)
        }
    });

    groupNames.map(name => {
        let title = name.charAt(0).toUpperCase() + name.slice(1);
        newData.push({criterion: title, data: []})
    });

    data.map(app => {

        let appCriterion = app[criterion] || `No ${criterion}`;

        if (Array.isArray(appCriterion)) {
            appCriterion = appCriterion.sort((a, b) => ('' + a[criterion]).localeCompare(b[criterion]))
            appCriterion = appCriterion.join(', ');
        }

        newData.map(newApp => {
            if (appCriterion.toLowerCase() === newApp.criterion.toLowerCase()) {
                newApp.data.push(app)
            }
        })
    });

    return processSorting('criterion', newData, descendant);
}


function processAppsSearch(search, apps, type, order) {

    const returnSearchResult = (app, search) => (app.name?.toLowerCase() || '').includes(search?.toLowerCase() || '');

    let {criterion, descendant} = order;
    let filteredApps = [];

    if (type === 'sort') {
        let _apps = processSorting(criterion, apps, descendant);
        filteredApps = _apps.filter(app => returnSearchResult(app, search));
    }

    if (type === 'group') {

        let _apps = processGrouping(criterion, apps, descendant);

        _apps.map(group => {
            if (group.data.some(_app => returnSearchResult(_app, search))) {
                filteredApps.push({
                    criterion: group.criterion,
                    data: group.data.filter(app => returnSearchResult(app, search))
                })
            }
        })
    }

    return filteredApps
}


export function processOrderChange(stacks, order, search) {


    let orderedAppData = [];
    let clonedAppData = JSON.parse(JSON.stringify(stacks));

    if (!search.length) {
        switch (true) {
            case order.type === 'sort':
                orderedAppData = processSorting(order.criterion, clonedAppData, order.descendant);
                break;
            case order.type === 'group':
                orderedAppData = processGrouping(order.criterion, clonedAppData, order.descendant);
                break;
            default :
                orderedAppData = processSorting('popularity', clonedAppData, true);
                break;
        }
    } else if (!!search.length) {
        orderedAppData = processAppsSearch(search, clonedAppData, order.type, order.tagsCriterion, order.descendant);
    }

    if (!!order.tags?.some(tag => tag.active)) {

        const freeTagIsActive = order.tags.some(t => t.title.toLowerCase() === 'free' && !!t.active);
        const isFree = app => !!app.requiredPlan && app.requiredPlan === '1';
        const checkAccordanceWithTags = (tag, app) => {
            // check if app's categories list includes selected tag
            if (tag.title.toLowerCase() === 'free' && !order.tags.some(t => t.title.toLowerCase() !== 'free' && !!t.active)) {
                return isFree(app) && tag.active
            } else {
                return app[order.tagsCriterion]?.includes(tag.title) && tag.active
            }
        };

        const divideIfFree = app => (freeTagIsActive && isFree(app) || !freeTagIsActive);

        if (order.type === 'sort') {
            orderedAppData = orderedAppData.filter(app => (
                order.tags.some(tag => checkAccordanceWithTags(tag, app) && divideIfFree(app))
            ));
        } else if (order.type === 'group') {
            orderedAppData = orderedAppData.filter(app => {
                app.data = app.data.filter(a => divideIfFree(a));
                return order.tags.some(tag => app.data.some(_app => checkAccordanceWithTags(tag, _app) && divideIfFree(_app)))
            })
        }
    }

    return orderedAppData
}

export function processQuery(query, order) {

    if (!!Object.keys(query || {}).length) {

        const tagsKeys = query?.tags?.split(',') || Object.keys(order.tags);
        // find and select tags that should be active :
        let _tags = [...order.tags];
        if (!!query.tags) {
            tagsKeys.map(key => {
                const newTag = order.tags.find(tag => tag.title === key || tag.title.toLowerCase() === key.toLowerCase());
                if (newTag) newTag.active = true;
            })
        }

        return {
            tags: _tags,
            type: query?.type || order.type,
            tagsCriterion: query?.tagsCriterion || order.tagsCriterion,
            descendant: query?.descendant || order.descendant,
            criterion: query?.criterion || order.criterion,
        };
    }
}